// Lazyloading
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'regenerator-runtime/runtime';

import contentDropdown from '../../../../../src24/js/modules/contentDropdown';
import map from '../../../../../src24/js/modules/map';
import header from '../../../../../src24/js/modules/header';
import sliderTeaser from '../../../../../src24/js/modules/sliderTeaser';
import printImage from '../../../../../src24/js/modules/printImage';
import share from '../../../../../src24/js/modules/share';
import newsTicker from '../../../../../src24/js/modules/newsTicker';
import elementStateToggle from '../../../../../src24/js/modules/elementStateToggle';
import tileRegistration from '../../../../../src24/js/modules/tileRegistration';
import videoLoader from '../../../../../src24/js/modules/videoLoader';
import simpleTabNavigation from '../../../../../src24/js/modules/simpleTabNavigation';
import loadMore from '../../../../../src24/js/modules/loadMore';
import accordion from '../../../../../src24/js/modules/accordion';
import sliderTeams from '../../../../../src24/js/modules/sliderTeams';
import sliderTestimonials from '../../../../../src24/js/modules/sliderTestimonials';
import sliderPartnerTeaser from '../../../../../src24/js/modules/sliderPartnerTeaser';
import partnerTeaser from '../../../../../src24/js/modules/partnerTeaser';
import copy from '../../../../../src24/js/modules/copy';
import popup from '../../../../../src24/js/modules/popup';
import cookieBot from '../../../../../src24/js/modules/cookieBot';
import sliderLocationTeaser from '../../../../../src24/js/modules/sliderLocationTeaser';
import audioPlayer from '../../../../../src24/js/modules/audioPlayer';
import frcCaptcha from '../../../../../src24/js/modules/frcCaptcha';
import crispSegments from '../../../../../src24/js/modules/crisp';
import helpSearch from '../../../../../src24/js/modules/helpSearch';
import iframeFullscreen from '../../../../../src24/js/modules/iframeFullscreen';

window.addEventListener('load', () => {
    partnerTeaser.init();
    contentDropdown.init();
    header.init();
    map.init();
    sliderTeaser.init();
    printImage.init();
    share.init();
    newsTicker.init();
    elementStateToggle.init({
        hasContextElement: {
            elements: '.js-state-context',
            attr: 'href',
        },
        scrollToTrigger: true,
        offset: -200,
        toggleActiveElement: true,
        removeAllActiveClasses: true,
    });
    tileRegistration();
    videoLoader.init();
    simpleTabNavigation.init();
    loadMore.init();
    accordion.init();
    sliderTeams.init();
    sliderPartnerTeaser.init();
    sliderTestimonials.init();
    sliderLocationTeaser.init();
    audioPlayer.init();
    copy();
    popup();
    cookieBot();
    frcCaptcha();
    crispSegments('triathlon');
    helpSearch.init();
    iframeFullscreen.init();
});
